import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import {
  getBranch,
  getParticularPage,
  getNext,
  getPrevious,
  createBranch,
  updateBranch,
  handleSearch,
  getBranchById,
} from "./thunk";

const initialState = {
  branches: [],
  edit: false,
  branch: null,
  count: null,
  pageNo: 1,
  next: null,
  previous: null,
  loading: false,
  loadingUpdated: false,
  loadingBranch: false,
  loadingNext: false,
  showCreateModal: false,
};

export const branchSlice = createSlice({
  name: "branch",
  initialState,
  reducers: {
    setShowCreateModal: (state, action) => {
      state.showCreateModal = action.payload;
    },
    goToPage: (state, { payload }) => {
      state.pageNo = payload;
    },
    clearAllBranch: (state) => {
      state.edit = false;
      state.loading = false;
      state.loadingUpdated = false;
      state.loadingBranch = false;
      state.branch = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(createBranch.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(createBranch.fulfilled, (state, action) => {
      state.loading = false;
      state.edit = false;
    });
    builder.addCase(createBranch.rejected, (state) => {
      state.loading = false;
      state.edit = false;
    });
    builder.addCase(getBranchById.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getBranchById.fulfilled, (state, action) => {
      state.loading = false;
      state.edit = true;
      state.branch = action.payload.data;
    });
    builder.addCase(getBranchById.rejected, (state) => {
      state.loading = false;
      state.edit = false;
      state.branch = null;
    });
    builder.addCase(updateBranch.pending, (state) => {
      state.loadingUpdated = true;
    });
    builder.addCase(updateBranch.fulfilled, (state, action) => {
      state.loadingUpdated = false;
      state.edit = false;
    });
    builder.addCase(updateBranch.rejected, (state) => {
      state.loadingUpdated = false;
    });
    builder.addMatcher(
      isAnyOf(getBranch.pending, getParticularPage.pending, getPrevious.pending, getNext.pending, handleSearch.pending),
      (state) => {
        state.loadingBranch = true;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getBranch.fulfilled,
        getParticularPage.fulfilled,
        getPrevious.fulfilled,
        getNext.fulfilled,
        handleSearch.fulfilled
      ),
      (state, action) => {
        state.loadingBranch = false;
        state.branches = action.payload.data;
        state.count = action.payload.totalCount;

        state.previous = action.payload.previous;
        state.next = action.payload.next;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getBranch.rejected,
        getParticularPage.rejected,
        getPrevious.rejected,
        getNext.rejected,
        handleSearch.rejected
      ),
      (state) => {
        state.loadingBranch = false;
      }
    );
  },
});

export const { setShowCreateModal, goToPage, clearAllBranch } = branchSlice.actions;

export default branchSlice.reducer;
